import React, { useContext, useEffect } from 'react'
import { RequestContext } from '../../../../context/RequestContext';
import { openModal } from '../../../../service/modal-service';
import { BookingCard, BookingFooter, PriceTileGrid, getServiceTheme } from './AirconBookingLayout';

// Ceiling cassette general servicing, same layout as AirconBooking but with a
// single service, so there are no tabs. serviceType is the AirconScope key.
const SERVICE_TYPE = 'generalCeiling'
const UNIT_TYPE = 'Ceiling'

// Quick-book prices for 1-5 ceiling units, kept exactly as they were
// previously hardcoded in the tiles. Note they differ from both the
// generalCeiling entries in utils/airconDeals and the page's pricing table.
const CASSETTE_RATES = ['57.41', '113.38', '145.08', '176.80', '199.42']

export const CassetteAirconBooking = (props) => {
    const setRequestForm = props.setRequestForm
    const oneTimeServicing = props.oneTimeServicing
    const setIsQuickBook = props.setIsQuickBook
    const setIsCustomBook = props.setIsCustomBook
    const setIsShowAirconItemSelection = props.setIsShowAirconItemSelection
    const showJobScope = props.showJobScope
    const currencyCd = props.currencyCd
    const title = props.title || 'Cassette Aircon Service'
    const subtitle = props.subtitle || 'Ensure Optimal Cooling with Professional Ceiling Cassette Aircon Servicing in Singapore'

    const { setRequestCriteria, setRequestDescription } = useContext(RequestContext);

    const quickBook = (airconCount) => {
        const criteria = [
            {1: 'General servicing for cleaning', criteria: 'Type of service - General servicing for cleaning'},
            {2: airconCount.toString(), criteria: "Number of aircon units to be serviced - " + airconCount},
            {21: 'Only once', criteria: 'Frequency of service - Only once'},
            {24: 'Ceiling', criteria: 'Mount type - Ceiling'}
        ]
        setRequestCriteria(criteria)
        setRequestDescription('Aircon Service')
        setIsQuickBook(true)
        // A quick book is not a custom (picker) booking, whatever came before
        setIsCustomBook(false)
        openModal(setRequestForm)
    }

    useEffect(() => {
        setRequestCriteria([])
        setRequestDescription('')
        setIsQuickBook(false)
        setIsCustomBook(false)
    }, [setIsQuickBook, setIsCustomBook, setRequestCriteria, setRequestDescription])

    const theme = getServiceTheme(SERVICE_TYPE)

    const tiles = CASSETTE_RATES.map((rate, i) => ({
        key: `${SERVICE_TYPE}-${i}`,
        label: oneTimeServicing[i].number,
        currencyCd: currencyCd,
        price: rate,
        ariaLabel: `Book ${oneTimeServicing[i].number} ceiling cassette aircon servicing`,
        onBook: () => quickBook(i + 1),
    }))

  return (
    // The page already has its own <h1> further down, so the card title stays an h3.
    <BookingCard title={title} subtitle={subtitle} headingAs='h3'>
        {/* Booking buttons */}
        <div className='pt-4 pb-2 px-4'>
            <PriceTileGrid
                tiles={tiles}
                theme={theme}
                onMore={() => setIsShowAirconItemSelection(true)}
            />
            <BookingFooter
                theme={theme}
                serviceType={SERVICE_TYPE}
                onShowDetails={() => showJobScope(SERVICE_TYPE, UNIT_TYPE)}
                highlights={['30 days warranty']}
            />
        </div>
    </BookingCard>
  )
}
